import React, { useState } from "react";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { TextField } from "@mui/material";

const libraries = ["places"];

export default function CitySearch({ value, label, onChange, ...restProps }) {
  const [autocompleteInstance, setAutocompleteInstance] = useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  // Called when user selects a place
  const handlePlaceSelect = () => {
    if (!autocompleteInstance) return;

    const place = autocompleteInstance.getPlace();
    if (!place || !place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    onChange && onChange({ lat, lng, ...place });
  };

  return isLoaded ? (
    <Autocomplete
      onLoad={(autocomplete) => setAutocompleteInstance(autocomplete)}
      onPlaceChanged={handlePlaceSelect}
    >
      <InputComponent label={label} value={value} {...restProps} />
    </Autocomplete>
  ) : (
    <InputComponent label={label} value={value} {...restProps} />
  );
}

const InputComponent = ({ label, value, ...restProps }) => {
  let props = { ...restProps };

  if (value) {
    props.InputLabelProps = { shrink: true };
  }

  return (
    <TextField
      size="small"
      placeholder={value}
      label={label || "Search cities"}
      {...props}
    />
  );
};
